import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';

export class AgingItemsResource extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     * @param {string} endpoint
     */
    constructor(apiClient, endpoint = 'items/agingInventoryItems') {
        super(apiClient, endpoint);
    }

    getAll() {
        return this.find();
    }

    getExpiredInventories() {
        return `${this.api.baseURL}/items/agingInventoryItems`;
    }

    getExportPath(isExpiredWindowView, dateRange) {
        const pIsExpiredWindowView = isExpiredWindowView == null ? false : isExpiredWindowView;
        const pDateRange = dateRange == null ? 0 : dateRange;
        return `${this.api.baseURL}/items/csv/agingInventoryItems?isExpiredWindowView=${pIsExpiredWindowView}&dateRange=${pDateRange}`;
    }
}

export default new AgingItemsResource(api);
